import { AnyObject } from '@vimeo/core/types/generic';

/**
 * Default supported HTTP methods enum.
 */
export enum ERequestMethod {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  PUT = 'PUT',
}

/**
 * Connection entry that allows to do generic requests.
 */
export interface IVimeoApiConnection {
  uri: string;
  options: Array<ERequestMethod>;
}

export interface IVimeoApiLink {
  name: string;
  uri: string;
}

export type TVimeoApiConnectionExtended<T extends AnyObject> = IVimeoApiConnection & T;
